import axios from "axios";
import {context} from "../context";

let config = {
    baseURL: context.baseUrl,
    withCredentials: true,
};
if (window && window.location) {
    let location = window.location;
    let origin = location.origin;
    config['Origin'] = origin;
}else {
    console.warn("Cannot fix Origin via window");
}
export default axios.create(config);
